import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'
import OutsideClickHandler from 'react-outside-click-handler'

import { isStandardAvailable } from '../../helpers'
import DropdownRow from './components/DropdownRow'

import infoIcon from '../../../../../../assets/modules/finance/info-icon.png'
import lockIcon from '../../../../../../assets/modules/finance/financeTable/lock.png'

import './style.scss'

export default class Header extends Component {
    static propTypes = {
        currentStandard: PropTypes.string,
        data: PropTypes.array,
        handleCurrentStandardChange: PropTypes.func,
        id: PropTypes.string.isRequired,
        isAdvanced: PropTypes.bool,
        sectionsDefinition: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                rows: PropTypes.arrayOf(
                    PropTypes.shape({
                        prefix: PropTypes.string,
                        highlight: PropTypes.bool,
                        text: PropTypes.string.isRequired,
                        columnCode: PropTypes.string.isRequired,
                        indentationLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                        configuration: PropTypes.shape({
                            unit: PropTypes.string,
                            higherIsBetter: PropTypes.string,
                        }),
                    })
                ).isRequired,
            })
        ),
        setOpenRows: PropTypes.func.isRequired,
        standards: PropTypes.array,
        tableType: PropTypes.string.isRequired,
        translates: PropTypes.shape({
            exportAsImage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            standardsText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            standardsDropdownText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            expandAll: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            collapseAll: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            noStandardSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            availableYears: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    static defaultProps = {
        isAdvanced: false,
    }

    constructor(props) {
        super(props)

        this.state = {
            dropdownActive: false,
        }
    }

    getAvailYearsRange = (standard) =>
        `(${_.get(standard, 'minAvailableYear')} - ${_.get(standard, 'maxAvailableYear')})`

    getYearsRange = (standard) => `(${_.get(standard, 'minYear')} - ${_.get(standard, 'maxYear')})`

    handleCloseDropdown = () => {
        this.setState({ dropdownActive: false })
    }

    handleDropdownRowClick = (standardType) => {
        const { handleCurrentStandardChange, tableType } = this.props

        handleCurrentStandardChange(tableType, standardType)
        this.setState({ dropdownActive: false })
    }

    handleExpandAllRowsClick = () => {
        const { id, setOpenRows, sectionsDefinition, tableType } = this.props

        // Array of all openable rows' columnCodes in finance table
        let allRows = []
        _.map(sectionsDefinition, (section) => {
            _.map(_.get(section, 'rows', []), (row) => {
                const columnCode = _.get(row, 'columnCode', null)

                // Take only rows that are openable
                if (_.find(_.get(section, 'rows', []), (x) => _.get(x, 'parentNode') === columnCode)) {
                    allRows = [...allRows, columnCode]
                }
            })
        })

        setOpenRows(id, tableType, allRows)
    }

    handleCollapseAllRowsClick = () => {
        const { id, setOpenRows, tableType } = this.props

        setOpenRows(id, tableType, [])
    }

    handleToggleDropdown = () => {
        const { dropdownActive } = this.state

        this.setState({ dropdownActive: !dropdownActive })
    }

    renderDropdownRows = () => {
        const { standards } = this.props

        return _.map(standards, (standard, index) => {
            const standardAvailability = isStandardAvailable(standard)

            // When the user has all the available years
            if (standardAvailability >= 1) {
                return (
                    <DropdownRow
                        key={`${_.get(standard, 'statementType', null)}-dropdown-row-${index}`}
                        handleDropdownRowClick={this.handleDropdownRowClick}
                        text={`${_.get(standard, 'shortDescription', 'statementType')} ${this.getAvailYearsRange(
                            standard
                        )}`}
                        statementType={_.get(standard, 'statementType', null)}
                        locked={false}
                    />
                )
            }
            if (standardAvailability < 0) {
                // When the user has no available years
                return (
                    <DropdownRow
                        key={`${_.get(standard, 'statementType', null)}-dropdown-row-${index}`}
                        handleDropdownRowClick={this.handleDropdownRowClick}
                        text={`${_.get(standard, 'shortDescription', 'statementType')} ${this.getYearsRange(standard)}`}
                        statementType={_.get(standard, 'statementType', null)}
                        locked
                    />
                )
            }

            // When the user has some available years (show row with available years plus another year with all years)
            return (
                <div>
                    <DropdownRow
                        key={`${_.get(standard, 'statementType', null)}-dropdown-row-${index}`}
                        handleDropdownRowClick={this.handleDropdownRowClick}
                        text={`${_.get(standard, 'shortDescription', 'statementType')} ${this.getAvailYearsRange(
                            standard
                        )}`}
                        statementType={_.get(standard, 'statementType', null)}
                        locked={false}
                    />
                    <DropdownRow
                        key={`${_.get(standard, 'statementType', null)}-dropdown-row-${index}-locked`}
                        handleDropdownRowClick={this.handleDropdownRowClick}
                        text={`${_.get(standard, 'shortDescription', 'statementType')} ${this.getYearsRange(standard)}`}
                        statementType={_.get(standard, 'statementType', null)}
                        locked
                    />
                </div>
            )
        })
    }

    render() {
        const { isAdvanced, data, translates, standards, currentStandard } = this.props
        const { dropdownActive } = this.state

        const currentStandardObj = _.find(standards, { statementType: currentStandard })
        const currentStandardDesc =
            isStandardAvailable(currentStandardObj) >= 0
                ? `${_.get(currentStandardObj, 'shortDescription')} ${this.getAvailYearsRange(currentStandardObj)}`
                : `${_.get(currentStandardObj, 'shortDescription')} ${this.getYearsRange(currentStandardObj)}`

        return (
            <div className={'fixed-column-header-content'}>
                <div>
                    {_.find(data, 'mainNace') && (
                        <div className={'nace-container'}>
                            <span className={'nace-text'}>
                                {`NACE ${_.get(_.find(data, 'mainNace'), 'mainNace.code')} - ${_.get(
                                    _.find(data, 'mainNace'),
                                    'mainNace.text'
                                )}`}
                            </span>
                        </div>
                    )}
                    {isAdvanced && standards.length > 1 && (
                        <div>
                            <div className={'standards-text'}>{translates.standardsText}</div>
                            <div className={'standards-available-years'}>
                                <span>
                                    <img src={infoIcon} alt={'info icon'} />
                                    {translates.availableYears}
                                    <img src={lockIcon} alt={'lock icon'} />
                                </span>
                            </div>
                            <div className={'standards-dropdown-title'}>{`${translates.standardsDropdownText}: `}</div>
                            {
                                <div className={'standards-dropdown-container'}>
                                    <OutsideClickHandler
                                        disabled={!dropdownActive}
                                        onOutsideClick={() => this.handleCloseDropdown()}
                                    >
                                        <span onClick={() => this.handleToggleDropdown()}>
                                            {`${
                                                !_.isNil(currentStandardObj)
                                                    ? currentStandardDesc
                                                    : translates.noStandardSelected
                                            }`}
                                        </span>
                                        <div className={classnames('dropdown-menu', dropdownActive && 'active')}>
                                            {this.renderDropdownRows()}
                                        </div>
                                    </OutsideClickHandler>
                                </div>
                            }
                        </div>
                    )}
                </div>
                <div className={'row-controls-container'}>
                    {isAdvanced && (
                        <div>
                            <button className={'row-controls-btn'} onClick={() => this.handleExpandAllRowsClick()}>
                                {translates.expandAll}
                            </button>
                            <button className={'row-controls-btn'} onClick={() => this.handleCollapseAllRowsClick()}>
                                {translates.collapseAll}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
